<template>
  <div class="interpreter-request-button d-flex flex-column">
    <b-button
      id="id-interpreter-request-btn"
      type="button"
      class="btn btn-rounded btn-light btn-block"
      pill
      variant="outline-info"
      :disabled="(currentConversation.operator_id !== currentUser.user_id)"
      @click.prevent="interpreterRequest()"
    >
      <b-icon-translate />&nbsp;&nbsp;Language Interpreter
    </b-button>

    <ConnectWithInterpreter v-if="showInterpreter" />
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import ConnectWithInterpreter from "../conversations/ConnectWithInterpreter.vue";

export default {
  name: "InterpreterRequestButton",
  components: {
    ConnectWithInterpreter,
  },
  props: {
    recipientId: String,
    conversationId: String,
    recipientLabel: String,
  },
  data() {
    return {
      showInterpreter: false,
    };
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency"]),
    ...mapGetters("conversations", ["currentConversation"])
  },
  methods: {
    interpreterRequest() {
      this.showInterpreter = !this.showInterpreter;
      // const $ = window.$;
      // $("#id-modal-container").modal({
      //   backdrop: "static"
      // });
      // EventBus.$emit("open", {
      //   component: ConnectWithInterpreter,
      //   title: "Connect with Interpreter",
      //   closeOnClick: false,
      // });
    }
  },
};
</script>

<style lang="scss">
.interpreter-request-button {
  gap: 1rem;
}
</style>
